export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q03_b.60a7cbd5.png";